<template>
  <div>
    <div>
      <div class="main-wrapper">
        <div>
          <!-- <layout-header2></layout-header2> -->
          <layout-header></layout-header>
          <breadcrumb1></breadcrumb1>
          <!-- Page Content -->
          <div class="content">
            <div class="container">
              <div class="row">
                <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
                  <sidebar></sidebar>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
                  <loader></loader>
                </div>
                <div class="col-md-7 col-lg-8 col-xl-9" v-else>
                  <div class="row" style="margin-top: -25px;">
                    <div class="col-md-12" id="patient_container">
                      <!-- <h3 class="mb-3">Patient Appointments on {{ currentDay }}, {{ todays_date }}</h3> -->
                      <!-- <h4 class="mb-4">Patient Appoinment</h4> -->
                      <div class="appointment-tab ml-md-4">
                        <!-- Appointment Tab -->
                        <ul class="nav nav-tabs nav-tabs-solid nav-tabs-rounded">
                          <li class="nav-item mr-1 mt-1 mb-1">
                            <!-- <p class="text-center">{{todays_appointment}}</p> -->
                            <a class="nav-link active" href="#today-appointments" data-toggle="tab">Today <span
                                class="rounded-brackets">{{ todays_appointment }}</span></a>
                          </li>
                          <li class="nav-item mr-1 mt-1">
                            <!-- <p class="text-center">{{ total_appointment }}</p> -->
                            <a class="nav-link" href="#upcoming-appointments" data-toggle="tab">
                              Upcoming <span class="rounded-brackets">{{ total_appointment }}</span>
                            </a>
                          </li>
                          <li class="nav-item mr-1 mt-1">
                            <!-- <p class="text-center">{{count_closed}}</p>  -->
                            <a class="nav-link" href="#closed-appointments" data-toggle="tab">Closed <span
                                class="rounded-brackets">{{ count_closed }}</span></a>
                          </li>
                          <li class="nav-item mr-1 mt-1">
                            <!-- <p class="text-center">{{cancel_appointment}}</p> -->
                            <a class="nav-link" href="#cancel-appointments" data-toggle="tab">Cancelled <span
                                class="rounded-brackets">{{ cancel_appointment }}</span></a>
                          </li>

                        </ul>
                        <!-- /Appointment Tab -->

                        <div class="tab-content ml-md-2">
                          <!-- Upcoming Appointment Tab -->
                          <div class="tab-pane" id="upcoming-appointments">
                            <div class="card card-table mb-0" style="border: none;">
                              <div class="card-body">
                                <div class="table-responsive">
                                  <table class="table table-hover table-center mb-0">
                                    <thead>
                                      <tr>
                                        <th style="background-color: #F8F8F8; width:200px;" class="text-left">Patient Name
                                        </th>
                                        <th style="background-color: #F8F8F8;" class="text-left">City</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Appt Date</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Status</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(item,
                                        $index) in upcoming_appointments" :key="item.id"
                                        v-show="setUpcomingPaginate($index)">
                                        <td class="text-left">
                                          <h2 class="table-avatar">
                                            <a href="javascript:void(0);" class="avatar avatar-sm mr-2"><img class="
                                                  avatar-img
                                                  rounded-circle
                                                " v-bind:src="item.image
                                                  ? config.base_url_for_Image +
                                                  item.image
                                                  : loadImg(
                                                    'Patient Profile.svg'
                                                  )
                                                  " alt="User Image" /></a>
                                            <a href="javascript:void(0);">{{ item.patient_name
                                            }}</a>
                                          </h2>
                                        </td>

                                        <td class="text-left">{{ item.city }}</td>
                                        <td class="text-left">
                                          {{
                                            convertDate(
                                              item.appointment_datetime
                                            )
                                          }}
                                          <span class="d-block text-info">{{
                                            convertTime(
                                              item.appointment_datetime
                                            )
                                          }}</span>
                                        </td>
                                        <td class="text-left">{{ item.status }}</td>
                                        <td class="text-left">
                                          <div class="table-action">
                                            <a href="javascript:void(0);" data-toggle="modal"
                                              data-target="#viewappointment" @click="
                                                viewappointmentdata(
                                                  item.name,
                                                  false
                                                )
                                                " class="btn btn-sm bg-info-light">
                                              <i class="far fa-eye"></i> View
                                            </a>

                                            <a href="javascript:void(0);" data-toggle="modal"
                                              data-target="#rescheduleappointment" class="
                                                btn btn-sm
                                                bg-success-light
                                              " @click="reschedule(item)">
                                              <i class="fas fa-check"></i>
                                              Reschedule
                                            </a>


                                            <b-button class="btn btn-sm bg-danger-light"
                                            @click="openCancelModal(
                                              item.patient_name,
                                              item.name
                                            )">
                                             <i class="fas fa-times"></i>
                                            Cancel
                              </b-button>


                                            <!-- <a @click="
                                              cancel_appointments(item.name, item.patient_name)
                                              " href="javascript:void(0);" class="btn btn-sm bg-danger-light">
                                              <i class="fas fa-times"></i>
                                              Cancel
                                            </a> -->
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <h5 v-if="upcoming_appointments.length === 0" class="No_data">
                                    No Appointments Found
                                  </h5>
                                </div>
                                <!-- pagination start -->
                                <div id="pagination" v-if="upcoming_appointments.length > 10">
                                  <ul class="pagination justify-content-center">

                                    <!-- "Previous" Button -->
                                    <li class="page-item" :class="upcoming_current === 1 ? 'disabled' : ''">
                                      <a href="#" class="page-link" aria-label="Previous"
                                        @click.prevent="updateUpcomingCurrent(upcoming_current - 1)">
                                        Previous
                                      </a>
                                    </li>

                                    <!-- Pagination Links (Display 5 at a time) -->
                                    <li v-for="page_index in upcoming_paginate_total" :key="page_index.id" :class="[
                                      'page-item',
                                      upcoming_current === page_index ? 'active' : ''
                                    ]" v-if="page_index >= upcoming_current - 2 && page_index <= upcoming_current + 2">
                                      <a href="#" class="page-link" @click.prevent="updateUpcomingCurrent(page_index)">
                                        {{ page_index }}
                                      </a>
                                    </li>

                                    <!-- "Next" Button -->
                                    <li class="page-item" :class="upcoming_current === upcoming_paginate_total ? 'disabled' : ''
                                      ">
                                      <a href="#" class="page-link" aria-label="Next"
                                        @click.prevent="updateUpcomingCurrent(upcoming_current + 1)">
                                        Next
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <!-- pagination end -->
                              </div>
                            </div>
                          </div>
                          <!-- /Upcoming Appointment Tab -->

                          <!-- Today Appointment Tab -->
                          <div class="tab-pane show active" id="today-appointments">
                            <div class="card card-table mb-0" style="border: none;">
                              <div class="card-body">
                                <div class="table-responsive">
                                  <table class="table table-hover table-center mb-0">
                                    <thead>
                                      <tr>
                                        <th style="background-color: #F8F8F8;" class="text-left">Patient Name</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">City</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Status</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Encounter Status</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(item,
                                        $index) in todays_appointments" :key="item.id"
                                        v-show="setTodayPaginate($index)">
                                        <td class="text-left">
                                          <h2 class="table-avatar">
                                            <a href="javascript:void(0);" class="avatar avatar-sm mr-2"><img class="
                                                  avatar-img
                                                  rounded-circle
                                                " v-bind:src="item.image
                                                  ? config.base_url_for_Image +
                                                  item.image
                                                  : loadImg(
                                                    'Patient Profile.svg'
                                                  )
                                                  " alt="User Image" /></a>
                                            <a href="javascript:void(0);">{{ item.patient_name
                                            }}</a>
                                          </h2>
                                        </td>
                                        <td class="text-left">{{ item.city }}</td>
                                        <td class="text-left">{{ item.status }}</td>
                                        <td class="text-left">
                                          {{ item.patient_encounter_status }}
                                        </td>
                                        <td class="text-left">
                                          <div class="table-action">
                                            <a href="javascript:void(0);" data-toggle="modal"
                                              data-target="#viewappointment" @click="
                                                viewappointmentdata(
                                                  item.name,
                                                  false
                                                )
                                                " class="btn btn-sm bg-info-light">
                                              <i class="far fa-eye"></i> View
                                            </a>
                                            <a href="javascript:void(0);" data-toggle="modal"
                                              data-target="#rescheduleappointment" class="
                                                btn btn-sm
                                                bg-success-light
                                              " @click="reschedule(item)"
                                              v-if="item.status !== 'Cancelled' && item.status !== 'Closed'">
                                              <i class="fas fa-check"></i>
                                              Reschedule
                                            </a>
                                            <!-- <a href="javascript:void(0);" class="btn btn-sm bg-info-light" @click="
                                              add_patient_encounter_new(
                                                item.patient,
                                                item.name,
                                                item.patient_encounter,
                                                item.patient_encounter_status
                                              )
                                              " v-if="item.status !== 'Cancelled' && item.status !== 'Closed'">
                                              <i class="far fa-eye"></i>
                                              Encounter
                                            </a> -->
                                            <b-button v-if="item.status !== 'Cancelled' && item.status !== 'Closed'" class="btn btn-sm bg-info-light"
                                            @click="openOtpModal(
                                              item.mobile,
                                              item.patient,
                                              item.name,
                                              item.patient_encounter
                                            )">
                                            Encounter
                              </b-button>


                              <b-button class="btn btn-sm bg-danger-light"
                              v-if="item.status !== 'Cancelled' && item.status !== 'Closed'"
                                            @click="openCancelModal(
                                              item.patient_name,
                                              item.name
                                            )">
                                             <i class="fas fa-times"></i>
                                            Cancel
                              </b-button>

                                            <!-- <a href="javascript:void(0);" @click="cancel_appointments(item.name, item.patient_name)"
                                              class="btn btn-sm bg-danger-light"
                                              v-if="item.status !== 'Cancelled' && item.status !== 'Closed'">
                                              <i class="fas fa-times"></i>
                                              Cancel
                                            </a> -->
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <h5 v-if="todays_appointments.length === 0" class="No_data">
                                    No Appointments Found
                                  </h5>
                                </div>
                                <!-- pagination start -->
                                <div id="pagination" v-if="todays_appointments.length > 10">
                                  <ul class="pagination justify-content-center">

                                    <!-- "Previous" Button -->
                                    <li class="page-item" :class="today_current === 1 ? 'disabled' : ''">
                                      <a href="#" class="page-link" aria-label="Previous"
                                        @click.prevent="updateTodayCurrent(today_current - 1)">
                                        Previous
                                      </a>
                                    </li>
                                    <!-- Pagination Links (Display 5 at a time) -->
                                    <li v-for="page_index in today_paginate_total" :key="page_index.id" :class="[
                                      'page-item',
                                      today_current === page_index ? 'active' : ''
                                    ]" v-if="page_index >= today_current - 2 && page_index <= today_current + 2">
                                      <a href="#" class="page-link" @click.prevent="updateTodayCurrent(page_index)">
                                        {{ page_index }}
                                      </a>
                                    </li>

                                    <!-- "Next" Button -->
                                    <li class="page-item" :class="today_current === today_paginate_total ? 'disabled' : ''
                                      ">
                                      <a href="#" class="page-link" aria-label="Next"
                                        @click.prevent="updateTodayCurrent(today_current + 1)">
                                        Next
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <!-- pagination end -->
                              </div>
                            </div>
                          </div>
                          <!-- /Today Appointment Tab -->

                          <!-- Closed Appointment Tab -->
                          <div class="tab-pane" id="closed-appointments">
                            <div class="card card-table mb-0" style="border: none;">
                              <div class="card-body">
                                <div class="table-responsive">
                                  <table class="table table-hover table-center mb-0">
                                    <thead>
                                      <tr>
                                        <th style="background-color: #F8F8F8;" class="text-left">Patient Name</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">City</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Appt Date</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Status</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Encounter Status</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(item,
                                        $index) in closed_appointments" :key="item.id"
                                        v-show="setClosedPaginate($index)">
                                        <td class="text-left">
                                          <h2 class="table-avatar">
                                            <a href="javascript:void(0);" class="avatar avatar-sm mr-2"><img class="
                                                  avatar-img
                                                  rounded-circle
                                                " v-bind:src="item.image
                                                  ? config.base_url_for_Image +
                                                  item.image
                                                  : loadImg(
                                                    'Patient Profile.svg'
                                                  )
                                                  " alt="User Image" /></a>
                                            <a href="javascript:void(0);">{{ item.patient_name
                                            }}</a>
                                          </h2>
                                        </td>
                                        <td class="text-left">{{ item.city }}</td>
                                        <td class="text-left">
                                          {{
                                            convertDate(
                                              item.appointment_datetime
                                            )
                                          }}<span class="d-block text-info">{{ convertTime(item.appointment_datetime)
}}</span>
                                        </td>
                                        <td class="text-left">{{ item.status }}</td>
                                        <td class="text-left">
                                          {{ item.patient_encounter_status }}
                                        </td>
                                        <td class="text-left">
                                          <div class="table-action">
                                            <a href="javascript:void(0);" class="btn btn-sm bg-info-light"
                                              @click="ClosedAppointment()">
                                              <router-link :to="{
                                                name:
                                                  'update-patient-encounter-update',
                                                params: {
                                                  patient_id: item.patient,
                                                  appointment_id: item.name,
                                                  encounter_id:
                                                    item.patient_encounter,
                                                },
                                              }">
                                                <i class="far fa-eye"></i>
                                                View Encounter
                                              </router-link>
                                            </a>
                                          </div>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <h5 v-if="closed_appointments.length === 0" class="No_data">
                                    No Appointments Found
                                  </h5>
                                </div>
                                <!-- pagination start -->
                                <div id="pagination" v-if="closed_appointments.length > 10">
                                  <ul class="pagination justify-content-center">

                                    <!-- "Previous" Button -->
                                    <li class="page-item" :class="closed_current === 1 ? 'disabled' : ''">
                                      <a href="#" class="page-link" aria-label="Previous"
                                        @click.prevent="updateClosedCurrent(closed_current - 1)">
                                        Previous
                                      </a>
                                    </li>

                                    <!-- Pagination Links (Display 5 at a time) -->
                                    <li v-for="page_index in closed_paginate_total" :key="page_index.id" :class="[
                                      'page-item',
                                      closed_current === page_index ? 'active' : ''
                                    ]" v-if="page_index >= closed_current - 2 && page_index <= closed_current + 2">
                                      <a href="#" class="page-link" @click.prevent="updateClosedCurrent(page_index)">
                                        {{ page_index }}
                                      </a>
                                    </li>

                                    <!-- "Next" Button -->
                                    <li class="page-item" :class="closed_current === closed_paginate_total ? 'disabled' : ''
                                      ">
                                      <a href="#" class="page-link" aria-label="Next"
                                        @click.prevent="updateClosedCurrent(closed_current + 1)">
                                        Next
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <!-- pagination end -->
                              </div>
                            </div>
                          </div>
                          <!-- /Closed Appointment Tab -->

                          <!-- Cancel Appointment Tab -->
                          <div class="tab-pane" id="cancel-appointments">
                            <div class="card card-table mb-0" style="border: none;">
                              <div class="card-body">
                                <div class="table-responsive">
                                  <table class="table table-hover table-center mb-0">
                                    <thead>
                                      <tr>
                                        <th style="background-color: #F8F8F8; width:200px;" class="text-left">Patient Name
                                        </th>
                                        <th style="background-color: #F8F8F8;" class="text-left">City</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Appt Date</th>
                                        <th style="background-color: #F8F8F8;" class="text-left">Status</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      <tr v-for="(item,
                                        $index) in cancelled_appointment" :key="item.id"
                                        v-show="setCancelledPaginate($index)">
                                        <td class="text-left">
                                          <h2 class="table-avatar">
                                            <a href="javascript:void(0);" class="avatar avatar-sm mr-2"><img class="
                                                  avatar-img
                                                  rounded-circle
                                                " v-bind:src="item.image
                                                  ? config.base_url_for_Image +
                                                  item.image
                                                  : loadImg(
                                                    'Patient Profile.svg'
                                                  )
                                                  " alt="User Image" /></a>
                                            <a href="javascript:void(0);">{{ item.patient_name
                                            }}</a>
                                          </h2>
                                        </td>
                                        <td class="text-left">{{ item.city }}</td>
                                        <td class="text-left">
                                          {{
                                            convertDate(
                                              item.appointment_datetime
                                            )
                                          }}<span class="d-block text-info">{{ convertTime(item.appointment_datetime)
}}</span>
                                        </td>

                                        <td class="text-left">{{ item.status }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                  <h5 v-if="cancelled_appointment.length === 0" class="No_data">
                                    No Appointments Found
                                  </h5>
                                </div>
                                <!-- pagination start -->
                                <div id="pagination" v-if="cancelled_appointment.length > 10">
                                  <ul class="pagination justify-content-center">

                                    <!-- "Previous" Button -->
                                    <li class="page-item" :class="cancelled_current === 1 ? 'disabled' : ''">
                                      <a href="#" class="page-link" aria-label="Previous"
                                        @click.prevent="updateCancelledCurrent(cancelled_current - 1)">
                                        Previous
                                      </a>
                                    </li>

                                    <!-- Pagination Links (Display 5 at a time) -->
                                    <li v-for="page_index in cancelled_paginate_total" :key="page_index.id" :class="[
                                      'page-item',
                                      cancelled_current === page_index ? 'active' : ''
                                    ]"
                                      v-if="page_index >= cancelled_current - 2 && page_index <= cancelled_current + 2">
                                      <a href="#" class="page-link" @click.prevent="updateCancelledCurrent(page_index)">
                                        {{ page_index }}
                                      </a>
                                    </li>

                                    <!-- "Next" Button -->
                                    <li class="page-item" :class="cancelled_current === cancelled_paginate_total ? 'disabled' : ''
                                      ">
                                      <a href="#" class="page-link" aria-label="Next"
                                        @click.prevent="updateCancelledCurrent(cancelled_current + 1)">
                                        Next
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <!-- pagination end -->
                              </div>
                            </div>
                          </div>
                          <!-- /Cancel Appointment Tab -->

                          <!-- All Appointment Tab -->
                          <div class="tab-pane" id="all-appointments">
                            <div class="card card-table mb-0" style="border: none;">
                              <div class="card-body">
                                <div class="table-responsive">
                                  <table class="table table-hover table-center mb-0">
                                    <tbody>
                                      <div class="
                                          appointments
                                          doctor-appointments-scrollbar
                                        " v-if="appointments.length">
                                        <div class="appointment-list" v-for="item in appointments" :key="item.id">
                                          <div class="profile-info-widget">
                                            <a href="javascript:void(0);" class="booking-doc-img">
                                              <div></div>
                                              <img v-bind:src="item.image
                                                ? config.base_url_for_Image +
                                                item.image
                                                : loadImg(
                                                  'Patient Profile.svg'
                                                )
                                                " alt="User Image" />
                                            </a>
                                            <div class="profile-det-info">
                                              <h3>
                                                <a href="javascript:void(0);">
                                                  {{ item.patient_name }}
                                                </a>
                                              </h3>
                                              <div class="patient-details">
                                                <h5>
                                                  <i class="far fa-clock"></i>{{
                                                    convertDate(
                                                      item.appointment_datetime
                                                    )
                                                  }}
                                                  ,
                                                  <span class="text-info">{{
                                                    convertTime(
                                                      item.appointment_datetime
                                                    )
                                                  }}</span>
                                                </h5>
                                                <h5>
                                                  <i class="
                                                      fas
                                                      fa-map-marker-alt
                                                    "></i>
                                                  {{
                                                    item.city ? item.city : "-"
                                                  }}
                                                </h5>
                                                <h5 class="mb-0">
                                                  <i class="fas fa-phone"></i>
                                                  {{
                                                    item.mobile
                                                    ? item.mobile
                                                    : "-"
                                                  }}
                                                </h5>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="appointment-action">
                                            <a href="#" class="btn btn-sm bg-info-light" data-toggle="modal"
                                              data-target="#appt_details">
                                              <router-link :to="{
                                                    name: 'new-patient-encounter',
                                                    params: {
                                                      patient_id: item.patient,
                                                      appointment_id: item.name,
                                                    },
                                                  }">
                                                <i class="far fa-eye"></i>
                                                View Encounter
                                              </router-link>
                                            </a>
                                            <a href="#" class="btn btn-sm bg-info-light" data-toggle="modal"
                                              data-target="#viewappointment" @click="
                                                viewappointmentdata(
                                                  item.name,
                                                  false
                                                )
                                                ">
                                              <i class="far fa-eye"></i> View
                                            </a>
                                            <a href="javascript:void(0);" data-toggle="modal"
                                              data-target="#rescheduleappointment" class="
                                                btn btn-sm
                                                bg-success-light
                                              " @click="reschedule(item)">
                                              <i class="fas fa-check"></i>
                                              Reschedule
                                            </a>
                                            <a class="btn btn-sm bg-danger-light">
                                              <i class="fas fa-times"></i>
                                              Cancel
                                            </a>
                                          </div>
                                        </div>
                                      </div>
                                    </tbody>
                                  </table>
                                  <h5 v-if="appointments.length === 0 && !showspinner
                                    " class="No_data">
                                    No Appointments Found
                                  </h5>
                                </div>
                              </div>
                            </div>
                          </div>
                          <!-- /All Appointment Tab -->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /Page Content -->
          <layout-footer></layout-footer>
        </div>
      </div>


<b-modal v-model="showOTPModal" title="Enter OTP and Upload File" size="md">
          <form>
            <div class="otp-container">
          <input v-for="(value, index) in otp" :key="index" type="text" maxlength="1" class="otp-input" :value="value"
            @input="handleInput(index, $event.target.value)" @keydown.backspace="handleBackspace(index)" ref="otpFields"
            @keypress="onlyNumber" pattern="[0-9]*" autofocus />
        </div>
        <div class="form-group mt-5">
        <label for="photo-capture">Capture Photo</label>
        <div class="camera-container">
          <div v-if="!isCameraOn">
            <button type="button" class="btn btn-primary mt-3" @click="startCamera">Start Camera</button>
          </div>
          <div v-else>
            <video id="camera" autoplay playsinline style="width: 100%;"></video>
            <button type="button" class="btn btn-warning mt-3" @click="capturePhoto">Capture Photo</button>
          </div>
          <canvas id="canvas" style="display: none;"></canvas>
          <img v-if="capturedImage" :src="capturedImage" class="captured-photo mt-3" alt="Captured Photo" />
        </div>
      </div>
        </form>
        <div class="mt-5 text-left">
          <b-button class="btn btn-success" @click="verifyOtp">
            Verify
          </b-button>
        </div>
      </b-modal>

      <b-modal v-model="showCancelModal" title="Confirm Cancellation" size="md">
      <div class="card p-5">
        <div class="row form-row">
          <div class="col-12 col-md-12">
            <div class="form-group">
              <label>Reason of Cancellation</label>
              <textarea class="form-control" id="reason_of_cancellation"
              v-model="custom_cancel_reason" rows="3" placeholder="Reason for Cancellation"></textarea>
            </div>
          </div>
        </div>
        <div class="submit-section">
          <button @click="submitCancelAppointment()" class="btn btn-primary submit-btn" data-dismiss="modal" aria-label="Close">
            Submit
          </button>
        </div>
      </div>
    </b-modal>

      <div class="modal fade custom-modal show" id="viewappointment">
        <div class="modal-dialog modal-dialog-centered modal-md appointment_modal">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Appointment</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="card">
                <div class="card-body">
                  <div class="row form-row">
                    <div class="col-12 col-md-12 text-center">
                      <div class="form-group">
                        <!-- <img src="@/assets/img/logo/helthcare_logo.jpeg" alt="logo" class="appointment_modal_logo"
                          style="width: 120px; height: 37px; margin-left: 90px;" /> -->
                          <img :src="config.base_url_for_Image + main_data" alt="logo" class="appointment_modal_logo"
                          style="height: 45px;"/>
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="widget-profile appointment-modal-no-border">
                        <div class="profile-info-widget">
                          <a class="booking-doc-img">
                            <img v-bind:src="appointments_details.image
                              ? config.base_url_for_Image +
                              appointments_details.image
                              : loadImg('Patient Profile.svg')
                              " alt="User Image" />
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="appointment-modal">
                        <h5>{{ appointments_details.patient_name }}</h5>
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="appointment-modal">
                        <h5>{{ appointments_details.mobile }}</h5>
                      </div>
                    </div>
                    <div class="text-center ml-5">
                    <div class="col-12 col-md-12 mt-4">
                      <div class="appointment-modal text-left">
                        <b style="color:black;" class="ml-1">Appointment Details</b>
                      </div>
                    </div>
                    <div class="col-12 col-md-12 mt-4">
                      <div class="appointment-modal text-left">
                        <label class="ml-1">Date :</label>
                        <label>{{
                          appointments_details.appointment_date
                        }}</label>
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="appointment-modal text-left">
                        <label class="ml-1">Time :</label>
                        <label>{{
                          appointments_details.appointment_time
                        }}</label>
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="appointment-modal text-left">
                        <label class="ml-1">Hospital :</label>
                        <label>{{ appointments_details.hospital }}</label>
                      </div>
                    </div>
                  </div>
                  </div>
                  <div class="text-center mt-4">
                    <a href="javascript:void(0);" class="btn btn-sm bg-primary-light" @click="
                      viewappointmentdata(appointments_details.name, true)
                      ">
                      <i class="fas fa-print"></i> Print
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="modal fade custom-modal show" id="viewappointment1">
        <div class="modal-dialog modal-dialog-centered modal-md appointment_modal">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Appointment</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <vue-html2pdf :show-layout="false" :float-layout="true" :enable-download="false" :preview-modal="true"
              :paginate-elements-by-height="1400" filename="appointment" :pdf-quality="2" :manual-pagination="false"
              pdf-format="a4" pdf-orientation="portrait" pdf-content-width="400px" @hasDownloaded="hasGenerated($event)"
              ref="html2Pdf">
              <section slot="pdf-content">
                <div class="modal-body">
                  <div class="card">
                    <div class="card-body">
                      <div class="row form-row">
                        <div class="col-12 col-md-12 text-center">
                          <div class="form-group">
                            <!-- <img src="@/assets/img/logo/helthcare_logo.jpeg" alt="logo" class="appointment_modal_logo"
                              style="width: 120px; height: 37px; margin-left: 100px;" /> -->
                              <img :src="config.base_url_for_Image + main_data" alt="logo" class="appointment_modal_logo"
                          style="height: 45px;"/>
                          </div>
                        </div>
                        <div class="col-12 col-md-12">
                          <div class="widget-profile appointment-modal-no-border">
                            <div class="profile-info-widget">
                              <a class="booking-doc-img">
                                <img v-bind:src="appointments_details.image
                                  ? config.base_url_for_Image +
                                  appointments_details.image
                                  : loadImg('Patient Profile.svg')
                                  " alt="User Image" />
                              </a>
                            </div>
                          </div>
                        </div>
                        <div class="col-12 col-md-12">
                          <div class="appointment-modal">
                            <h5>{{ appointments_details.patient_name }}</h5>
                          </div>
                        </div>
                        <div class="col-12 col-md-12">
                          <div class="appointment-modal">
                            <h5>{{ appointments_details.mobile }}</h5>
                          </div>
                        </div>
                        <div class="text-center ml-5">
                        <div class="col-12 col-md-12 mt-4">
                          <div class="appointment-modal text-left">
                            <b style="color:black;" class="ml-4">Appointment Details</b>
                          </div>
                        </div>
                        <div class="col-12 col-md-12 mt-4">
                          <div class="appointment-modal text-left">
                            <label class="ml-4">Date :</label>
                            <label>{{
                              appointments_details.appointment_date
                            }}</label>
                          </div>
                        </div>
                        <div class="col-12 col-md-12">
                          <div class="appointment-modal text-left">
                            <label class="ml-4">Time :</label>
                            <label>{{
                              appointments_details.appointment_time
                            }}</label>
                          </div>
                        </div>
                        <div class="col-12 col-md-12">
                          <div class="appointment-modal text-left">
                            <label class="ml-4">Hospital :</label>
                            <label>{{
                              appointments_details.hospital
                            }}</label>
                          </div>
                        </div>
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </vue-html2pdf>
          </div>
        </div>
      </div>

      <div class="modal fade custom-modal show" id="rescheduleappointment">
        <div class="modal-dialog modal-dialog-centered modal-md reschedule_modal">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Reschedule Appointment</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeModal">
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="card">
                <div class="card-body">
                  <div class="row form-row">
                    <div class="col-12 col-md-12">
                      <textarea class="form-control" id="reason_of_reschedule"
                      v-model="custom_reschedule_reason" rows="3" placeholder="Reason of Reschedule"></textarea>
                    </div>
                    <div class="col-12 col-md-12 mt-3">
                      <div class="form-group">
                        <h4 v-if="selected_object != undefined" class="mb-1" id="alternate_date">
                          {{ get_moment(selected_object).format("D MMMM YYYY") }}
                        </h4>
                        <p v-if="selected_object != undefined" class="text-muted">
                          {{ get_moment(selected_object).format("dddd") }}
                        </p>
                        <h4 v-if="selected_object == undefined">Select Appointment Date</h4>
                      </div>
                      <div class="col-12 col-sm-4 col-md-6 text-sm-right">
                        <div class="bookingrange btn btn-white btn-sm mb-3">
                          <VueDatePicker v-model="selected_date" placeholder="Choose date" color="#15558d"
                            :minDate="disabledDates" @onChange="get_slots" />
                        </div>
                      </div>
                    </div>
                    <div class="col">
                      <div class="form-group">
                        <div class="card booking-schedule schedule-widget" v-if="selected_object != undefined">
                          <!-- Schedule Header -->
                          <div class="schedule-header">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="day-slot" v-if="next_days.length > 0">
                                  <ul v-if="selected_object != undefined">
                                    <li v-for="(day, index) in next_days" :key="index" @click="change_date(day)">
                                      <div :class="{
  'font-weight-bold': get_moment(day).format('MMM Do YY') === get_moment(selected_object).format('MMM Do YY'),
  'reshedule_active_item': day === selected_object,
  'green-text': get_moment(day).format('ddd') === selected_day, 
}">
                                        <span style="font-size:15px;">{{ get_moment(day).format("ddd") }}</span>
                                        <span class="slot-date" style="font-size:13px;">{{ get_moment(day).format("D MMM YY") }}</span>
                                      </div>
                                    </li>
                                  </ul>
                                </div>
                                <!-- /Day Slot -->
                              </div>
                            </div>
                          </div>
                          <!-- /Schedule Header -->
                          <div class="schedule-cont" v-if="slots != undefined">
                            <div class="row">
                              <div class="col-md-12">
                                <!-- Time Slot -->
                                <div class="time-slot">
                                  <ul>
                                    <li>Slot Number and Estimated Time</li>
                                  </ul>
                                  <ul class="clearfix">
                                    <li v-for="(slot, index) in slots" :key="index">
                                      <a :id="slot.name" class="timing" :class="active_slot === index ? 'active' : ''"
                                        @click="set_slot(slot, index)" :disabled="slot.booked">
                                        <span class="slot_number">{{ slot.slot_no }}</span>
                                        <br />
                                        <span>{{ slot.from_time.slice(0, 5) }}</span>

                                        <!-- Add this line to display the slot number -->
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                <!-- /Time Slot -->
                              </div>
                            </div>
                          </div>
                          <div v-else class="mt-2 mb-2 text-center" style="color:black;">
                          {{ not_data }}
                        </div>
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-12">
                      <div class="text-center mt-4">
                        <div class="submit-section text-left"
                          v-if="selected_object != undefined && selected_slot != undefined">
                          <button type="submit" id="medical_btn" class="btn btn-primary submit-btn" data-dismiss="modal"
                            aria-label="Close" :disabled="disabled" @click="Reschedule_appointments()">
                            Reschedule
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>
<style scoped>
.aligninput {
  margin: 0 1rem 0 0;
}

.custom_class {
  max-width: 170px;
  text-align: left;
  width: 100%;
  float: right;
}

.timing {
  cursor: pointer;
}

.day-slot ul li {
  cursor: pointer;
}

.container.booking {
  min-height: 50vh;
}

a[disabled="disabled"] {
  pointer-events: none;
  cursor: default;
}
</style>

<script>
import CommonApi from "@/services/CommonApi";
import { mapState } from "vuex";
import config from "../../../services/CommonApi";
const images = require.context("@/assets/img/patients");
import { VueDatePicker } from "@mathieustan/vue-datepicker";
const doctorimages = require.context("@/assets/img/doctors");
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";
import VueHtml2pdf from "vue-html2pdf";
import axios from "axios";

export default {
  data() {
    return {
      otp: ["", "", "", "", "", ""],
      selectedFile: null, 
      capturedImage:null,
      selectedFileName: "",
      isCameraOn: false, // Track whether the camera is on
      videoStream: null, // Store the camera stream
      encounterName: "",
      encounter_status:"",
      mobile: "",
      appointment_id: "",
      patient_id: "",
      showOTPModal: false,
      showCancelModal:false,
      custom_cancel_reason:"",
      newPatientName:"",
      UserName:"",
      isEmailVerified: false,
      not_data:"",
      main_data:"",
      total_appointment: "",
      todays_appointment: "",
      todays_date: new Date()
        .toString()
        .split(" ")
        .splice(1, 3)
        .join(" "),
      count_closed: "",
      cancel_appointment: "",
      patient_name: "",
      selected_date: null,
      selected_day: null,
      disabledDates: new Date(),
      selected_object: undefined,
      next_days: [],
      slot_no: "",
      slots: undefined,
      selected_slot: undefined,
      custom_reschedule_reason:"",
      encounter_modes: [],
      selected_hospital: "",
      active_slot: undefined,

      download: false,
      fake_appointments_details: {},
      format: "dd-MM-yyyy",
      appointments: [],
      showspinner: true,
      config: config,
      disabled: true,

      upcoming_appointments: [],
      todays_appointments: [],
      closed_appointments: [],
      cancelled_appointment: [],

      reschedule_appointment: {
        hospital: "",
        appointment_type: "",
        patient: "",
        practitioner: this.$store.state.user.user_id,
        service_unit: "",
        appointment_id: "",
        appointment_date: "",
        appointment_time: "",
      },

      appointments_details: {
        patient_name: "",
        mobile: "",
        appointment_date: "",
        appointment_time: "",
        hospital: "",
        image: "",
      },

      //pagination
      upcoming_current: 1,
      upcoming_paginate: 10,
      upcoming_paginate_total: 0,

      today_current: 1,
      today_paginate: 10,
      today_paginate_total: 0,

      closed_current: 1,
      closed_paginate: 10,
      closed_paginate_total: 0,

      cancelled_current: 1,
      cancelled_paginate: 10,
      cancelled_paginate_total: 0,
    };

  },
  components: { VueDatePicker, VueHtml2pdf },
  mounted() {

    let user = localStorage.getItem("userInfo");
    if(!user){
      this.$router.push({name:'login'})
    }

    $("#booking-from").datetimepicker({
      format: "DD/MM/YYYY",
      icons: {
        up: "fas fa-chevron-up",
        down: "fas fa-chevron-down",
        next: "fas fa-chevron-right",
        previous: "fas fa-chevron-left",
      },
    });
    // this.get_patient_appointment_list_all();
    this.get_patient_appointment_upcoming(),
    this.get_patient_appointment_list_today(),
    this.get_patient_appointment_list_closed();
    this.get_patient_appointment_list_canceled();
    this.get_patient_appointment_count_upcoming();
    this.get_patient_appointment_count_today();
    this.get_patient_appointment_count_closed();
    this.get_patient_appointment_count_cancel();
    this.get_practitioner_profile();
  },
  computed: {
    ...mapState({
      user_id: (state) => state.user.user_id,
      closedAppointment: (state) => state.user.closedAppointment,

    }),

    currentDay() {
      const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
      const today = new Date().getDay(); // Get the current day of the week (0-6)

      return daysOfWeek[today];
    },
    reschedule_validation() {
      return (
        this.reschedule_appointment.appointment_date &&
        this.reschedule_appointment.appointment_time
      );
    },
  },
  watch: {
    showOTPModal(newVal) {
    if (newVal && this.isCameraOn === false) {
      this.startCamera();
    } else if (!newVal && this.isCameraOn) {
      this.stopCamera();
    }
  },
    reschedule_validation() {
      if (
        this.reschedule_appointment.appointment_date === "" ||
        this.reschedule_appointment.appointment_time === ""
      ) {
        this.disabled = true;
      } else {
        this.disabled = false;
      }
    },
    fake_appointments_details: {
      handler() {
        if (this.download) {
          setTimeout(this.generateReport(), 2000);
        }
      },
      deep: true,
    },
  },
  methods: {

    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    handleInput(index, value) {
      if (value.length > 1) {
        return;
      }
      this.otp[index] = value;
      if (value.length === 1 && index < this.otp.length - 1) {
        this.$refs.otpFields[index + 1].focus();
      }
    },


    async startCamera() {
  try {
    // Set the flag to display the video element
    this.isCameraOn = true;

    // Use $nextTick to ensure the video element is rendered in the DOM
    this.$nextTick(async () => {
      // Wait for the modal and video element to be rendered
      const videoElement = document.getElementById("camera");

      if (videoElement) {
        // Now, start the camera only if the video element is successfully referenced
        this.videoStream = await navigator.mediaDevices.getUserMedia({ video: true });
        videoElement.srcObject = this.videoStream; // Assign the camera stream to the video element
      } else {
        console.error("Video element not found in DOM.");
        this.$swal.fire("Error", "Unable to access the video element. Please try again.", "error");
      }
    });
  } catch (error) {
    console.error("Error accessing camera:", error);
    this.$swal.fire("Error", "Unable to access camera. Please check permissions.", "error");
  }
},

  // Method to capture the photo
  capturePhoto() {
    const video = document.getElementById("camera");
    if (!video) {
      console.error("Cannot find video element to capture the photo.");
      this.$swal.fire("Error", "Video element not found. Please restart the camera.", "error");
      return;
    }

    const canvas = document.getElementById("canvas");
    if (!canvas) {
      console.error("Cannot find canvas element to draw the image.");
      return;
    }

    const context = canvas.getContext("2d");

    // Set canvas size to match the video element's dimensions
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;

    // Draw the video frame to the canvas
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    this.capturedImage = canvas.toDataURL("image/jpeg"); // Store the captured image as a data URL
    this.selectedFile = this.dataURLtoFile(this.capturedImage, "photo.jpg");

    // Stop the camera after capturing the photo
    this.stopCamera();
  },

  // Stop the camera
  stopCamera() {
    if (this.videoStream) {
      const tracks = this.videoStream.getTracks();
      tracks.forEach((track) => track.stop());
      this.isCameraOn = false;
    }
  },
  dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, { type: mime });
  },


    handleBackspace(index) {
      if (this.otp[index] !== "") {
        this.otp[index] = "";
      } else if (index > 0) {
        this.$refs.otpFields[index - 1].focus();
      }
    },
    openOtpModal(itemName, appointment_id, patient_id) {
      this.encounterName = itemName; 
      this.appointment_id = appointment_id,
      this.patient_id = patient_id
      this.sendOtp();
      this.showOTPModal = true;
      if (!newVal && this.isCameraOn) {
        this.stopCamera(); // Stop the camera when the modal is closed
      }
    },

    // Method to close the modal
    closeOtpModal() {
      this.otp = "";
      this.selectedFile = null;
      this.selectedFileName = "";
      this.showOTPModal = false;
    },


    openCancelModal(patientId,patient_name) {
      this.newPatientName = patient_name;
      this.UserName = patientId;
      this.showCancelModal = true;
    },

    // Method to close the modal
    closeCancelModal() {
      this.custom_cancel_reason = "";
      this.showCancelModal = false;
    },

    onFileSelected(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.selectedFileName = file.name;
      }
    },

    async sendOtp() {
      try {
        const params = new URLSearchParams();
        params.append("phone", this.encounterName);
        const response = await CommonApi.get_data("sahaj.api.send_otp_registered_user", params);
        if (response && response.status_code === 200) {
          // this.$swal.fire("Success", "OTP sent successfully", "success");
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: response.message,
            showConfirmButton: true,
          });
          this.showOTPModal = false;
        }
      } catch (error) {
        this.$swal.fire({
          icon: "error",
          title: "Error",
          text: response.message,
          showConfirmButton: true,
        });
        this.showOTPModal = false;
      }
    },


    async verifyOtp() {
  const base64File = await this.getBase64(this.selectedFile);
  const fullOtp = this.otp.join("");

  if (fullOtp.trim() === "") {
    this.$swal.fire({
      icon: "warning",
      title: "Warning",
      text: "Please enter a valid OTP.",
    });
    return;
  }

  try {
    // Prepare JSON payload
    const payload = {
      phone: this.encounterName,
      otp: fullOtp,
    };

    // Verify OTP API Call using JSON payload
    const response = await CommonApi.post_data("sahaj.api.verify_otp_code", JSON.stringify(payload));

    if (response && response.status_code === 200) {
      // OTP Verification successful
      this.$swal.fire({
        icon: "success",
        title: "Success",
        text: "OTP verified successfully!",
      });

      // Call add_patient_encounter_new method after OTP verification is successful
      await this.add_patient_encounter_new(base64File);
    } else {
      this.$swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Invalid OTP. Please try again.",
      });
    }
  } catch (error) {
    console.error("Error verifying OTP:", error);
    this.$swal.fire({
      icon: "error",
      title: "Error",
      text: "An error occurred while verifying the OTP. Please try again.",
    });
  }
},

    // Helper method to convert file to base64
    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });
    },


    async get_practitioner_profile() {
      var domain = window.location.hostname;

      const formdata = {
        domain: window.location.hostname,
      };
      await axios
        .get(
          "https://develop-physio.kneexpert.in/api/method/sahaj.domain.get_hospital?domain=" +
          window.location.hostname
        )
        .then((res) => {
          this.showspinner = false;
          if (res.data.status_code == 200) {
            this.main_data = res.data.data[0].logo
          }
          if (res.data.status_code == 404) {
            if (window.location.hostname == "physio.sahajhelp.com") {
            } else if (window.location.hostname == "physio.kneexpert.in") {
            } else if (window.location.hostname == "localhost") {
            } else if (window.location.hostname.startsWith("192.168")) {
            } else if (window.location.hostname == "iitb.smartyhealthcare.in") {
            } else {
              window.location.href = String("https://physio.kneexpert.in");
            }
          }

          this.$swal.close();
        });
    },

    closeModal() {
      location.reload();
    },

    get_patient_appointment_count_upcoming() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.finalapi.get_patient_appointment_count_upcoming",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.total_appointment = res.data[0].count;
        }
      });
    },

    get_patient_appointment_count_today() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.finalapi.get_patient_appointment_count_today",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.todays_appointment = res.data[0].count;
        }
      });
    },

    get_patient_appointment_count_closed() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.finalapi.get_patient_appointment_count_closed",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.count_closed = res.data[0].count;
        }
      });
    },

    get_patient_appointment_count_cancel() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.finalapi.get_patient_appointment_count_cancelled",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.cancel_appointment = res.data[0].count;
        }
      });
    },

    async get_slots() {
      this.slots = undefined;
      this.active_slot = undefined;
      this.next_days = [];
      this.selected_day = this.get_moment(this.selected_date).format("ddd");
      this.selected_object = new Date(this.selected_date);
      for (var i = 0; i <= 6; i++) {
        var currentDate = new Date(this.selected_date);
        currentDate.setDate(this.selected_object.getDate() + i);
        this.next_days.push(currentDate);
      }

      let search = new URLSearchParams({
        date: this.selected_date,
        practitioner: this.user_id,
      });
      await CommonApi.get_data(
        "sahaj.appointment.get_availability_data",
        search
      ).then((res) => {
        if (res.message !== "Not Available") {
        let slots = res.data.slot_details;
        this.slots = slots.find(
          (x) => x.hospital === this.reschedule_appointment.hospital).avail_slot;
        }else{
          this.not_data = res.data;
        }
      });
    },

    get_moment(obj) {
      return moment(obj);
    },
    set_slot(slot, index) {
      this.selected_slot = slot;
      this.active_slot = index;
      $("a.timing").removeClass("selected");
      $("#" + slot.name).addClass("selected");
    },
    async change_date(day) {
    this.selected_object = day;
    this.selected_day = this.get_moment(day).format("ddd");
    this.active_slot = undefined;

    let search = new URLSearchParams({
      date: this.get_moment(day).format("YYYY-MM-DD"),
      practitioner: this.user_id,
    });
    this.selected_date = this.get_moment(day).toDate();
    await CommonApi.get_data(
      "sahaj.appointment.get_availability_data",
      search
    ).then((res) => {
      let slots = res.data.slot_details;
      this.slots = slots.find(
        (x) => x.hospital === this.reschedule_appointment.hospital
      ).avail_slot;
    });
  },

    // pagination
    setUpcomingPaginate(i) {
      if (this.upcoming_current == 1) {
        return i < this.upcoming_paginate;
      } else {
        return (
          i >= this.upcoming_paginate * (this.upcoming_current - 1) &&
          i < this.upcoming_current * this.upcoming_paginate
        );
      }
    },

    updateUpcomingCurrent(i) {
      this.upcoming_current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    setTodayPaginate(i) {
      if (this.today_current == 1) {
        return i < this.today_paginate;
      } else {
        return (
          i >= this.today_paginate * (this.today_current - 1) &&
          i < this.today_current * this.today_paginate
        );
      }
    },

    updateTodayCurrent(i) {
      this.today_current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    setClosedPaginate(i) {
      if (this.closed_current == 1) {
        return i < this.closed_paginate;
      } else {
        return (
          i >= this.closed_paginate * (this.closed_current - 1) &&
          i < this.closed_current * this.closed_paginate
        );
      }
    },

    setCancelledPaginate(i) {
      if (this.cancelled_current == 1) {
        return i < this.cancelled_paginate;
      } else {
        return (
          i >= this.cancelled_paginate * (this.cancelled_current - 1) &&
          i < this.cancelled_current * this.cancelled_paginate
        );
      }
    },

    updateClosedCurrent(i) {
      this.closed_current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    updateCancelledCurrent(i) {
      this.cancelled_current = i;
      document.getElementById("patient_container").scrollIntoView();
    },

    // pagination end

    loadImg(imgPath) {
      return images("./" + imgPath);
    },

    ClosedAppointment() {
      this.$store.dispatch("user/closedAppointment", true);
    },

    loadDoctorImg(imgPath) {
      return doctorimages("./" + imgPath);
    },

    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },

    hasGenerated(blob) {
      let url = URL.createObjectURL(blob);
      window.open(url); //opens the pdf in a new tab
    },


    /* Add Patient Encounter Data */
async add_patient_encounter_new(base64File) {
  var innerData = {
    appointment: this.patient_id,
    patient: this.appointment_id,
    practitioner: this.$store.state.user.user_id,
    encounter_file_name: this.selectedFileName,
    encounter_file: base64File,
  };

  var data = new FormData();
  data.append("data", JSON.stringify(innerData));

  await CommonApi.post_data("sahaj.api.add_patient_encounter_new", data).then((response) => {
    if (response && response.status_code === 200) {
      this.$swal.fire({
        icon: "success",
        title: "Success",
        text: response.message,
      });
      this.closeOtpModal();
      this.$store.dispatch("user/closedAppointment", false);
      this.$router.push(
        `/doctor/update-patient-encounter/${this.patient_id}/${this.appointment_id}/${response.data}`
      );
    } else {
      this.$swal.fire({
        icon: "error",
        title: "Error",
        text: response.message || "Failed to create encounter.",
      });
    }
  });
},


    /* Get Upcoming Appointment Data */
    get_patient_appointment_upcoming() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.finalapi.get_patient_appointment_upcoming",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.upcoming_appointments = res.data;
          this.upcoming_paginate_total = Math.ceil(
            this.upcoming_appointments.length / this.upcoming_paginate
          );
        }
      });
    },

    /* Get Today Appointment Data */
    get_patient_appointment_list_today() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.finalapi.get_patient_appointment_list_today",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.todays_appointments = res.data;
          this.today_paginate_total = Math.ceil(
            this.todays_appointments.length / this.today_paginate
          );
        }
      });
    },

    /* Get Closed Appointment Data */
    get_patient_appointment_list_closed() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.finalapi.get_patient_appointment_list_closed",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.closed_appointments = res.data;
          this.closed_paginate_total = Math.ceil(
            this.closed_appointments.length / this.closed_paginate
          );
        }
      });
    },

    /* Get Cancel Appointment Data */
    get_patient_appointment_list_canceled() {
      let data = {
        practitioner: this.user_id,
      };
      CommonApi.post_data(
        "sahaj.finalapi.get_patient_appointment_cancelled",
        data
      ).then((res) => {
        this.showspinner = false;
        if (res.status_code == 200) {
          this.cancelled_appointment = res.data;
          this.cancelled_paginate_total = Math.ceil(
            this.cancelled_appointment.length / this.cancelled_paginate
          );
        }
      });
    },

    /* Convert Appointment Date */
    convertAppointmentDate(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
      }
    },
    /* Convert Date */
    // convertDate(str) {
    //   if (str === null || str === "") {
    //     return "";
    //   } else {
    //     var date = new Date(str),
    //       mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    //       day = ("0" + date.getDate()).slice(-2);
    //     return [day, mnth, date.getFullYear()].join("-");
    //   }
    // },
    
    convertDate(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          mnth = ("0" + (date.getMonth() + 1)).slice(-2),
          day = ("0" + date.getDate()).slice(-2),
          year = date.getFullYear().toString().slice(-2); // Get last two digits of the year
        return [day, mnth, year].join("-");
      }
    },
    /* Get time */
    convertTime(str) {
      if (str === null || str === "") {
        return "";
      } else {
        var date = new Date(str),
          time =
            ("00" + date.getHours()).slice(-2) +
            ":" +
            ("00" + date.getMinutes()).slice(-2) +
            ":" +
            ("00" + date.getSeconds()).slice(-2);
        var H = +time.substr(0, 2);
        var h = H % 12 || 12;
        var ampm = H < 12 ? " AM" : " PM";
        var timeString = h + time.substr(2, 3) + ampm;
        return timeString;
      }
    },

    reschedule(item) {
      this.patient_name = item.patient_name;
      this.reschedule_appointment.patient = item.patient;
      this.reschedule_appointment.hospital = item.hospital;
      this.reschedule_appointment.appointment_type = item.appointment_type;
      this.reschedule_appointment.appointment_id = item.name;
      this.reschedule_appointment.service_unit = item.service_unit;
      this.reschedule_appointment.appointment_date = this.selected_date;
      this.reschedule_appointment.appointment_time = this.selected_slot;
      this.reschedule_appointment.slot_no = this.selected_slot;
    },

    Reschedule_appointments() {
      if (!this.disabled) {
        const fromTime = this.selected_slot ? this.selected_slot.from_time : '';
        const slotNum = this.selected_slot ? this.selected_slot.slot_no : '';
        let data = {
          custom_reschedule_reason:this.custom_reschedule_reason,
          reschedule_appointment: this.reschedule_appointment
            .reschedule_appointment,
          patient: this.reschedule_appointment.patient,
          hospital: this.reschedule_appointment.hospital,
          appointment_type: this.reschedule_appointment.appointment_type,
          practitioner: this.$store.state.user.user_id,
          service_unit: this.reschedule_appointment.service_unit,
          appointment_id: this.reschedule_appointment.appointment_id,
          appointment_date: this.selected_date,
          appointment_time: fromTime,
          slot_no: slotNum
        };
        CommonApi.post_data(
          "sahaj.finalapi.reschedule_appointment",
          JSON.stringify(data)
        ).then((res) => {
          this.showspinner = false;
          if (res.status_code == 500) {
            const dateParts = this.selected_date.split('-');
            const formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`;
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: `You already have an Open appointment with this Doctor on this date - ${formattedDate}`,
              showConfirmButton: true,
            });
          } else {
            const formattedTime = moment(this.selected_slot.from_time, 'HH:mm').format('hh:mm A');
            this.$swal.fire({
              icon: "success",
              title: "Appointment Reschedule Successfully!",
              text:
                "Appointment Reschedule with " +
                this.patient_name +
                " on " +
                this.get_moment(this.selected_object).format("D MMMM YYYY") +
                " " +
                formattedTime,
              showConfirmButton: true,
            }).then(() => {
              window.location.reload();
            });
          }
        });
      }
    },

    /* Cancel Appointment */
    // cancel_appointments() {
    //   this.$swal
    //     .fire({
    //       title: "Cancel Appointment",
    //       text: `Are you sure you want to cancel the appointment with ${this.newPatientName}?`,
    //       icon: "warning",
    //       showCancelButton: true,
    //       confirmButtonColor: "#3085d6",
    //       confirmButtonText: "Confirm",
    //       cancelButtonText: "Cancel",
    //       cancelButtonColor: "#d33",
    //     })
    //     .then((result) => {
    //       if (result.value) {
    //         this.$swal({
    //           text: "Canceling your appointment...",
    //           showConfirmButton: false,
    //           allowOutsideClick: false,
    //           didOpen: () => {
    //             this.$swal.showLoading();
    //           },
    //         });
    //         let data = {
    //           appointment_id: UserName,
    //           custom_cancel_reason:this.custom_cancel_reason
    //         };
    //         CommonApi.post_data("sahaj.finalapi.cancel_appointment", data).then(
    //           (res) => {
    //             if (res) {
    //               this.$swal.fire({
    //                 icon: "success",
    //                 title: "Success",
    //                 text: res.message,
    //                 showConfirmButton: true,
    //               }).then(() => {
    //                 // window.location.reload();
    //               });
    //               this.get_patient_appointment_list_all();
    //             } else {
    //               this.$swal.fire({
    //                 icon: "error",
    //                 title: "Error",
    //                 text: res.message,
    //                 showConfirmButton: true,
    //               });
    //             }
    //           }
    //         );
    //       }
    //     });
    // },


submitCancelAppointment() {
    // Ensure a reason is provided
    if (!this.custom_cancel_reason.trim()) {
      this.$swal.fire("Error", "Please enter a reason for cancellation.", "error");
      return;
    }

    // Prepare data for the API call
    let data = {
    appointment_id: this.newPatientName,
    custom_cancel_reason: this.custom_cancel_reason,
  };

    // Call the API to cancel the appointment with a reason
    CommonApi.post_data("sahaj.finalapi.cancel_appointment", data).then((response) => {
      if (response && response.status_code === 200) {
        this.$swal.fire("Success", "Appointment cancelled successfully!", "success").then(() => {
          this.showCancelModal = false;
        });
      } else {
        this.$swal.fire("Error", response.message || "Failed to cancel appointment.", "error");
      }
    }).catch((error) => {
      console.error("API Error:", error);
      this.$swal.fire("Error", "An error occurred while cancelling the appointment.", "error");
    });
  },


    viewappointmentdata(id, value) {
      this.download = value;
      this.get_appointment_popup_details(id, value);
    },

    /* Get Specific Appointment Data */
    get_appointment_popup_details(id, value) {
      var bodyFormData = new FormData();
      bodyFormData.append("name", id);
      CommonApi.post_data(
        "sahaj.api.get_appointment_popup_details",
        bodyFormData
      ).then((res) => {
        if (res.status_code == 200) {
          this.appointments_details.name = res.data[0].name;
          this.appointments_details.hospital = res.data[0].hospital;
          this.appointments_details.patient_name = res.data[0].patient_name;
          this.appointments_details.mobile = res.data[0].mobile;
          this.appointments_details.appointment_date =
            res.data[0].appointment_date;
            const appointmentTimeParts = res.data[0].appointment_time.split(':');
          if (appointmentTimeParts.length === 3) { // Check if it has seconds
            const [hours, minutes, seconds] = appointmentTimeParts;
            const ampm = hours >= 12 ? 'PM' : 'AM';
            this.appointments_details.appointment_time = `${hours % 12}:${minutes} ${ampm}`;
          } else if (appointmentTimeParts.length === 2) {
            const [hours, minutes] = appointmentTimeParts;
            const ampm = hours >= 12 ? 'PM' : 'AM';
            this.appointments_details.appointment_time = `${hours % 12}:${minutes} ${ampm}`;
          } else {
            // Handle invalid format or missing time parts
            this.appointments_details.appointment_time = "Invalid Time";
          }
          this.appointments_details.image = res.data[0].image;
          if (value) {
            this.fake_appointments_details = res.data[0];
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.appointment-modal {
  display: block;
  text-align: center;
}

.appointment-modal-no-border {
  border: none !important;
}

/* .active {
  background-color: #66CDAA !important;
  color: #fff !important;
} */

.active {
  background-color: #66CDAA !important;
  color: #fff !important;
}

.slot_number {
  background-color: #4682B4;
  color: #fff;
  padding-left: 6px;
  padding-right: 6px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 100%;
}

.rounded-brackets {
  font-size: 14px;
  /* Adjust the font size as needed */
  display: inline-flex;
  /* Use flex display to center the content */
  align-items: center;
  /* Center content vertically within the bracket */
  border: 1px solid #F8F8F8;
  /* Border style for the brackets */
  border-radius: 50%;
  /* Creates a fully round shape */
  padding: 5px 10px;
  /* Adjust padding as needed */
  margin: 0 5px;
  /* Adjust margin as needed to control spacing */
}

table {
  border-collapse: collapse;
  width: 100%;
  border-top: 1px solid #dddddd;
  /* Add an upper border */
}

th,
td {
  border: 1px solid #dddddd;
  /* You can adjust the border width and color as needed */
  padding: 8px;
  text-align: left;
}

th {
  background-color: #F8F8F8;
}

.reshedule_active_item {
  color: #66CDAA;
}

.submit-btn:hover {
  background-color: #008080;
}

.submit-btn:active {
  background-color: #008080;
}

.green-text {
    color: #66CDAA;
  }

  .captured-photo {
  max-width: 100%;
  border: 2px solid #ddd;
  border-radius: 8px;
}

.camera-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#camera {
  width: 100%;
  height: auto;
  border: 2px solid #ddd;
  border-radius: 8px;
}

  .otp-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-input {
  width: 40px;
  height: 40px;
  text-align: center;
  font-size: 24px;
  margin: 0 10px;
  border: none;
  border-bottom: 2px solid #403636;
  box-shadow: none;
  background-color: transparent;
  color: #140b0b;
  transition: all 0.3s ease-in-out;
  font-family: Arial, Helvetica, sans-serif;
}

.otp-input:focus {
  outline: none;
  border-bottom: 2px solid #09e5ab;
}

</style>



// WEBPACK FOOTER //
// src/components/kneexpert/doctor/Appointments.vue